module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registerb"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("商户管理后台")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [(_vm.isRegister) ? _c('el-form-item', {
    attrs: {
      "label": "业务员手机号",
      "prop": "saleman_mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number",
      "placeholder": "请输入业务员手机号"
    },
    model: {
      value: (_vm.form.saleman_mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "saleman_mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.saleman_mobile"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isRegister) ? _c('el-form-item', {
    attrs: {
      "label": "账户手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isRegister) ? _c('el-form-item', {
    attrs: {
      "label": "账号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number",
      "placeholder": "请输入注册账号"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "yanz"
  }, [_c('el-form-item', {
    attrs: {
      "label": "验证码",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), (_vm.isSendCode) ? _c('el-button', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getCode
    }
  }, [(_vm.isSending) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("获取验证码")])]) : _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill send"
  }, [_vm._v(_vm._s(_vm.buttonCotent))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "输入新密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入确认新密码"
    },
    model: {
      value: (_vm.form.repass),
      callback: function($$v) {
        _vm.$set(_vm.form, "repass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.repass"
    }
  })], 1), _vm._v(" "), (_vm.isRegister) ? _c('el-form-item', {
    attrs: {
      "label": "商户名称",
      "prop": "shopname"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入商户名称"
    },
    model: {
      value: (_vm.form.shopname),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.shopname"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确定")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb23eb6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/register.vue
// module id = 845
// module chunks = 1